<template>
  <v-textarea
    class="media-list-notes-textarea"
    :disabled="!$canControlNodeAndPod() || !editable"
    v-model="noteModel"
    :messages="message"
    :error="error"
    @focus="focused"
    @blur="blurred"
    :hide-details="isDetailsHidden"
    :label="$t('routes.node.note')"
    flat
    variant="solo-filled"
    density="compact"
    rows="3"
  />
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';

export default {
  name: "PodItemNote",
  props: {
    mediaPod: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  data() {
    return {
      noteModel: "",
      originalValue: "",
      success: false,
      error: false,
      message: "",
    };
  },
  mounted() {
    this.noteModel = this.mediaPod.note || "";
    this.originalValue = this.mediaPod.note || "";
  },
  methods: {
    focused() {
      this.setNeutral();
      // Store the original value when user starts editing
      this.originalValue = this.noteModel;
    },
    async blurred() {
      // Normalize values for comparison (handle null/undefined vs empty string)
      const currentValue = (this.noteModel || "").trim();
      const originalValue = (this.originalValue || "").trim();

      // Only send request if there's an actual change
      if (currentValue === originalValue || !this.editable) {
        return;
      }

      if (this.noteModel && this.noteModel.length >= 4096) {
        this.setError(this.$t('menus.createNode.nodeNoteMaxLength'));
        return;
      }

      const payload = {
        podId: this.mediaPod.id,
        note: this.noteModel,
      };

      const podStore = usePodStore();
      try {
        await podStore.updatePodNote(payload);

        // Check if the component has been unmounted
        if (!this || !this.$t) {
          return;
        }

        // Update the original value after successful save
        this.originalValue = this.noteModel;
        this.setSuccess(this.$t('routes.node.notesUpdated'));
      } catch (error) {
        // Reset to original value on error
        this.noteModel = this.originalValue;
        if (error && error.response && error.response.data && error.response.data.error) {
          this.setError(error.response.data.error.message);
        } else {
          this.setError("Error!");
          console.log(error);   // unhandled error
        }
      }
    },
    setError(message) {
      this.success = false;
      this.error = true;
      this.$showMessage(message, { type: "error" });
    },
    setSuccess(message) {
      this.success = true;
      this.error = false;
      this.$showMessage(message, { type: "success" });
    },
    setNeutral() {
      this.success = false;
      this.error = false;
      this.message = "";
    }
  },
  computed: {
    isDetailsHidden() {
      if (this.message && this.message.length > 0) {
        return false;
      }

      return true;
    }
  },
  watch: {
    'mediaPod.note': function(newValue) {
      if (newValue !== this.noteModel) {
        this.noteModel = newValue || "";
        this.originalValue = newValue || "";
      }
    }
  }
};
</script>

<style lang="scss">
.media-list-notes-textarea {
  font-size: 14px;
  line-height: 18px;

  textarea {
    line-height: 18px;
    overflow-x: hidden; /* Fix for firefox bug #33654 */
  }

  .v-text-field__details {
    margin-bottom: 0;
  }

  .v-label.v-field-label {
    visibility: hidden;
  }
}
</style>
